import { render, staticRenderFns } from "./print-claim.component.vue?vue&type=template&id=617c071e&"
import script from "./print-claim.component.vue?vue&type=script&lang=ts&"
export * from "./print-claim.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports